import request from '@/utils/request';
export const topSellingProducts = params => request({
  url: '/reports/item-wise-report',
  method: 'get',
  params
});
export const topDealers = params => request({
  url: '/reports/sales-report',
  method: 'get',
  params
});
export const totalOutstanding = params => request({
  url: '/orders-dispatches/outstanding-total',
  method: 'get',
  params
});
export const totalCollection = data => request({
  url: '/orders-dispatches/collection',
  method: 'post',
  data
});
export const totalFySales = params => request({
  // url: '/orders-dispatches/fy-sales-value',
  url: '/reports/fy-sales',
  method: 'get',
  params
});
export const totalFyPayment = params => request({
  // url: 'ledgers/fy-payments',
  url: 'reports/fy-payments',
  method: 'get',
  params
});
export const totalCurrentRecievable = params => request({
  url: 'orders-dispatches/current-recievable',
  method: 'get',
  params
});
export const totalPendingOrders = params => request({
  url: 'orders/total-order-pending',
  method: 'get',
  params
});
export const getCurrentMonthSales = params => request({
  url: '/orders-dispatches/current-month-sales',
  method: 'get',
  params
});
export const getCurrentMonthPayments = params => request({
  url: '/ledgers/current-month-payment',
  method: 'get',
  params
});
export const getPreviousMonthSales = params => request({
  url: '/orders-dispatches/previous-month-sales',
  method: 'get',
  params
});
export const getPreviousMonthPayments = params => request({
  url: '/ledgers/previous-month-payment',
  method: 'get',
  params
});
export const getDailyOrderValue = params => request({
  url: '/orders/daily-order-value',
  method: 'get',
  params
});
export const getCurrentMonthOrderValue = params => request({
  url: '/orders/current-month-order-value',
  method: 'get',
  params
});
export const getOverdueByDays = data => request({
  url: '/orders-dispatches/overdue-by-days',
  method: 'post',
  data
});
export const getLast3DaysAddedUsers = params => {
  return request({
    url: '/dealers-users/last-3-days-created-users',
    method: 'get',
    params
  });
};